export const SIDEBAR_WIDTH_EXPANDED = 260
export const SIDEBAR_WIDTH_COLLAPSED = 98
export const HEADER_HEIGHT_DESKTOP = 65
export const HEADER_HEIGHT_MOBILE = 56

// NEUTRAL_SCALE[900] (#2c3e50) is the intended background color for dark action
// buttons such as "Filtra" and "Esporta". Use it directly in component styles
// rather than augmenting MUI's palette.action (which is reserved for interaction
// states like hover/selected/disabled).
export const NEUTRAL_SCALE = {
  900: '#2c3e50',
  700: '#374151',
  500: '#6B7280',
  300: '#D1D5DB',
  200: '#E5E7EB',
  100: '#F3F4F6',
  50:  '#F9FAFB',
} as const

export const APP_BACKGROUND = '#f5f5f5'

export const CARD_BORDER_RADIUS = '12px'
export const CARD_BORDER_COLOR = '#f0f0f0'

// Shared height for all inline controls (Button, SearchBar, Select, etc.)
// so toolbar rows stay perfectly aligned.
export const CONTROL_HEIGHT = '40px'

export const SEMANTIC = {
  success: {main: '#16A34A', light: '#DCFCE7', dark: '#166534', border: '#BBF7D0'},
  warning: {main: '#CA8A04', light: '#FEF9C3', dark: '#854D0E', border: '#FDE047'},
  error:   {main: '#DC2626', light: '#FEE2E2', dark: '#991B1B', border: '#FECACA'},
  info:    {main: '#2563EB', light: '#DBEAFE', dark: '#1E40AF', border: '#BFDBFE'},
} as const
